import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import Tag from '../../components/Tag';
// import { Link } from 'react-router-dom';

function getDurationString(duration) {
    switch (duration) {
        case '4':
            return {
                key: 'hrs_2',
                number: 2
            };
        case '8':
            return {
                key: 'hrs_4',
                number: 4
            };
        case '9':
            return {
                key: 'full_day',
                number: 8
            };
        case '10': 
            return {
                key: 'hrs_12',
                number: 12
            }
        default:
            return 0;
    }
}

function getTypeSalaString(tipo_sala) {
    const types = {
        Chica: 'type_small',
        Mediana: 'type_medium',
        Grande: 'type_large'
    }

    return types[tipo_sala] || 'type_large';
}

class CardRoom extends Component {
    handleClick(event, room) {
        event.stopPropagation();
        this.props.handleBookRoom(room.id)
    }

    render() {
        const rooms = this.props.rooms;
        const duration = this.props.duration;
        const durationString = getDurationString(duration);
        const { t } = this.props;
        return (
            <div className="list-card-resvations" >
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="row list list2">
                            {rooms.map((room, index) => (
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 card-panel-rooms" key={index} onClick={() => this.props.handleBookRoomPlus(room.id)}>
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading" style={{ backgroundImage: "url('" + room.imagen + "')" }}>
                                        </div>
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{room.name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="panel-description-text">
                                                    {room.descripcion.slice(0, 150)}{room.descripcion.length > 150 ? '...' : null}
                                                </div>
                                                <div className="panel-description-information">
                                                    <div className="flex-tags flex-tags__big" style={{ margin: 'auto' }}>
                                                        <Tag
                                                            isBigTag
                                                            icon='people-group'
                                                            text={t("venta_linea.reservation_tags.capacity")}
                                                            value={`${room.capacidad} personas`}
                                                        />

                                                        <Tag
                                                            isBigTag
                                                            alt
                                                            icon='couch'
                                                            text={t("venta_linea.reservation_tags.room")}
                                                            value={room.tipo_sala}
                                                        />

                                                        <Tag
                                                            isBigTag
                                                            icon='dollar-sign'
                                                            text={
                                                                <Trans i18nKey='dashboard.reservations.price_capacity'>
                                                                    {{
                                                                        count: durationString.number,
                                                                    }}
                                                                </Trans>
                                                            }
                                                            value={room[durationString.key] + (room.moneda_id === 1 ? ' MXN' : ' USD')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="form-group">
                                                    <button
                                                        onClick={(e) => this.handleClick(e, room)}
                                                        className="btn btn-block btn-primary"
                                                        type="button">
                                                        <Trans>venta_linea.index.sala.reserve</Trans>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(CardRoom);


// WEBPACK FOOTER //
// ./src/store/Reservation/CardRoom.js